// TODO port this to streams - https://phrac.deviantart.net/D23153
// TODO add error handling
// TODO convert to use tooltip library
import * as tslib_1 from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import omit from 'lodash/omit';
import throttle from 'lodash/throttle';
import LoadingIndicator from '../LoadingIndicator';
import NoLeakyScroll from '../NoLeakyScroll';
import SearchIcon from '../Icons/Search';
import CloseIcon from '../Icons/CloseBold';
import { IconSize } from '../Icons/IconWrap';
import { withMobileContext } from '../Context';
import s from './EmoteSelector.scss';
export var EmoteStreams;
(function (EmoteStreams) {
    EmoteStreams["OFFICIAL"] = "official";
    EmoteStreams["COMMUNITY"] = "community";
    EmoteStreams["SEARCH"] = "search";
    EmoteStreams["USER"] = "user";
})(EmoteStreams || (EmoteStreams = {}));
var EmoteSelector = /** @class */ (function (_super) {
    tslib_1.__extends(EmoteSelector, _super);
    function EmoteSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.scrollContainerRef = React.createRef();
        _this.rootRef = React.createRef();
        _this.state = {
            isSearching: false,
            searchQuery: '',
            searchFocus: false,
            searchType: 'community',
        };
        _this.outsideClickHandler = function (e) {
            if (!_this.rootRef.current) {
                return;
            }
            if (!_this.rootRef.current.contains(e.target)) {
                _this.props.onClose && _this.props.onClose(e);
            }
        };
        _this.openSearch = function () {
            var activeStream = _this.props.activeStream;
            var searchType = activeStream === 'user' ? 'user' : 'community';
            _this.resetScroll();
            _this.setState({ isSearching: true, searchType: searchType });
        };
        _this.doSearch = function () {
            _this.resetScroll();
            _this.props.onSwitchStream &&
                _this.props.onSwitchStream(EmoteStreams.SEARCH, _this.state.searchQuery, _this.state.searchType);
        };
        _this.closeSearch = function () {
            _this.setState({
                searchQuery: '',
                isSearching: false,
                searchType: 'community',
            });
            _this.openOfficial();
        };
        _this.openOfficial = function () {
            _this.resetScroll();
            _this.props.onSwitchStream &&
                _this.props.onSwitchStream(EmoteStreams.OFFICIAL, _this.state.searchQuery, 'community');
        };
        _this.openCommunity = function () {
            _this.resetScroll();
            _this.props.onSwitchStream &&
                _this.props.onSwitchStream(EmoteStreams.COMMUNITY, _this.state.searchQuery, 'community');
        };
        _this.openUser = function () {
            _this.resetScroll();
            _this.props.onSwitchStream &&
                _this.props.onSwitchStream(EmoteStreams.USER, _this.state.searchQuery, 'user');
        };
        _this.searchUpdate = function (e) {
            _this.setState({ searchQuery: e.target.value });
        };
        _this.searchFocus = function (e) {
            _this.setState({ searchFocus: true });
        };
        _this.searchBlur = function (e) {
            _this.setState({ searchFocus: false });
        };
        _this.searchKeyDown = function (e) {
            if (e.key === 'Escape') {
                _this.setState({ searchQuery: '', isSearching: false });
            }
            if (e.key === 'Enter') {
                e.target.blur();
                _this.props.onSwitchStream &&
                    _this.props.onSwitchStream(EmoteStreams.SEARCH, _this.state.searchQuery, _this.state.searchType);
            }
        };
        _this.selectEmote = function (emote) {
            _this.props.onEmoteSelect && _this.props.onEmoteSelect(emote);
            _this.props.onClose && _this.props.onClose({});
        };
        _this.handleContainerScroll = throttle(function (e) {
            requestAnimationFrame(function () {
                if (e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight) <
                    100) {
                    if (!_this.props.isLoading &&
                        _this.props[_this.props.activeStream + "Emotes"] &&
                        _this.props[_this.props.activeStream + "Emotes"].hasMore) {
                        _this.props.onLoadMore &&
                            _this.props.onLoadMore(_this.props.activeStream);
                    }
                }
            });
        }, 300);
        _this.resetScroll = function () {
            if (!_this.scrollContainerRef.current) {
                return;
            }
            _this.scrollContainerRef.current.children[0].scrollTop = 0;
        };
        return _this;
    }
    EmoteSelector.prototype.componentDidMount = function () {
        this.props.onInitialize && this.props.onInitialize();
        document.addEventListener('click', this.outsideClickHandler, true);
        this.scrollContainerRef.current &&
            this.scrollContainerRef.current.addEventListener('scroll', this.handleContainerScroll, true);
    };
    EmoteSelector.prototype.componentWillUnmount = function () {
        if (typeof document === 'undefined') {
            return;
        }
        this.outsideClickHandler &&
            document.removeEventListener('click', this.outsideClickHandler, true);
        if (this.scrollContainerRef.current) {
            this.scrollContainerRef.current.removeEventListener('scroll', this.handleContainerScroll);
        }
    };
    EmoteSelector.prototype.renderTabs = function () {
        var _a = this.props, t = _a.t, activeStream = _a.activeStream;
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { onClick: this.openOfficial, className: classnames(s['tab'], s['official'], activeStream === EmoteStreams.OFFICIAL && s['selected']) }, t('emoteselector.official')),
            React.createElement("button", { onClick: this.openCommunity, className: classnames(s['tab'], s['community'], activeStream === EmoteStreams.COMMUNITY && s['selected']) }, t('emoteselector.community')),
            React.createElement("button", { onClick: this.openUser, className: classnames(s['tab'], activeStream === EmoteStreams.USER && s['selected']) }, t('emoteselector.user')),
            React.createElement("button", { onClick: this.openSearch, className: s['tab'] },
                React.createElement(SearchIcon, { size: IconSize.SMALL, className: s['search'] }))));
    };
    EmoteSelector.prototype.renderSearch = function () {
        var t = this.props.t;
        var searchType = this.state.searchType;
        return (React.createElement(React.Fragment, null,
            React.createElement("input", { autoFocus: true, className: s['search-input'], type: "text", placeholder: " " + (searchType !== 'community'
                    ? t('emoteselector.search.users')
                    : t('emoteselector.search')), onChange: this.searchUpdate, onFocus: this.searchFocus, onBlur: this.searchBlur, onKeyDown: this.searchKeyDown }),
            React.createElement("button", { onClick: this.closeSearch, className: s['tab'] },
                React.createElement(CloseIcon, { size: IconSize.SMALL, className: s['close'] }))));
    };
    EmoteSelector.prototype.renderEmotes = function () {
        var _this = this;
        var _a = this.props, officialEmotes = _a.officialEmotes, communityEmotes = _a.communityEmotes, searchEmotes = _a.searchEmotes, activeStream = _a.activeStream, userEmotes = _a.userEmotes;
        var emotes;
        switch (activeStream) {
            case EmoteStreams.COMMUNITY:
                emotes = communityEmotes && communityEmotes.results;
                break;
            case EmoteStreams.SEARCH:
                emotes = searchEmotes && searchEmotes.results;
                break;
            case EmoteStreams.USER:
                emotes = userEmotes && userEmotes.results;
                break;
            default:
                emotes = officialEmotes && officialEmotes.results;
        }
        if (!emotes || emotes.length === 0) {
            return this.renderNotFound();
        }
        return emotes.map(function (emote, i) { return (React.createElement(Emote, tslib_1.__assign({ key: i }, emote, { onClick: _this.selectEmote }))); });
    };
    EmoteSelector.prototype.renderNotFound = function () {
        var t = this.props.t;
        return (React.createElement("div", { className: s['notfound'] },
            React.createElement(SearchIcon, { size: IconSize.HUGE, className: classnames(s['notfound-icon']) }),
            t('emoteselector.notfound')));
    };
    EmoteSelector.prototype.render = function () {
        var isSearching = this.state.isSearching;
        var _a = this.props, buttonRect = _a.buttonRect, isLoading = _a.isLoading, isLoadingStream = _a.isLoadingStream, isMobile = _a.isMobile;
        var styles;
        var arrowRight = false;
        var arrowSize = 10;
        var popupWidth = 260;
        var popupHeight = 250;
        var hideArrow = false;
        // position menu to the left of icon on mobile
        // or if there's not enough space and it would show offscreen
        if ((isMobile || buttonRect.left + popupWidth / 2 > window.innerWidth) &&
            buttonRect.left - popupWidth > 0) {
            styles = {
                top: buttonRect.top + window.scrollY + popupWidth / 2 + arrowSize / 2,
                left: buttonRect.left - popupWidth - arrowSize * 2,
            };
            arrowRight = true;
        }
        else {
            styles = {
                top: buttonRect.top + window.scrollY - arrowSize / 2,
                left: buttonRect.left - popupWidth / 2 + arrowSize / 2,
            };
        }
        // Make sure we are not off screen, if we are bring it back into the
        // screen area and hide the arrow
        if (styles.left < 0) {
            styles.left = 0;
            hideArrow = true;
        }
        if (styles.top - popupHeight < 0) {
            styles.top = popupHeight + 15;
            hideArrow = true;
        }
        styles.top = styles.top + "px";
        styles.left = styles.left + "px";
        return (React.createElement("div", { ref: this.rootRef, style: styles, className: classnames(s['wrapper'], s['top']) },
            React.createElement("div", { className: s['container'] },
                React.createElement("div", { className: s['content'] },
                    React.createElement("div", { className: s['header'] },
                        isSearching && this.renderSearch(),
                        !isSearching && this.renderTabs()),
                    React.createElement("div", { className: s['items'], ref: this.scrollContainerRef },
                        React.createElement(NoLeakyScroll, null,
                            !isLoadingStream && this.renderEmotes(),
                            (isLoading || isLoadingStream) && (React.createElement(LoadingIndicator, { view: "llama", className: s['loading'] })),
                            React.createElement("div", { className: s['overlay'] })))),
                !hideArrow && (React.createElement("div", { className: classnames(s['arrow'], arrowRight && s['arrow-right']) })))));
    };
    return EmoteSelector;
}(React.Component));
export { EmoteSelector };
// TODO add lazy loading
var Emote = function (props) {
    var type = props.type, src = props.src, title = props.title, onClick = props.onClick;
    var styles = {
        backgroundImage: "url(" + src + ")",
    };
    var stylesHover = {
        backgroundImage: "url(" + src + "), linear-gradient(45deg, rgba(76, 221, 189, .18), rgba(6, 242, 134, .18))",
    };
    var over = function (e) {
        if (e.target && e.target.style) {
            e.target.style.backgroundImage = stylesHover.backgroundImage;
        }
    };
    var out = function (e) {
        if (e.target && e.target.style) {
            e.target.style.backgroundImage = styles.backgroundImage;
        }
    };
    return (React.createElement("button", { onClick: function () { return onClick(omit(props, ['onClick'])); }, onMouseOver: over, onMouseOut: out, className: classnames(s['emote'], type === EmoteStreams.OFFICIAL && s['emote-pixel']), style: styles },
        React.createElement("span", null, title)));
};
export default withMobileContext(withTranslation()(EmoteSelector));
//# sourceMappingURL=EmoteSelector.js.map